// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RRda8SCSLagsA5KgyDGC{flex-grow:1;margin-left:16px;display:flex;position:relative}.DQlregtNJkgFyyigQadG{background:var(--black-10);border-radius:6px;padding:4px 8px}.PqysIWggYQGNzoj7FWrc{display:flex}.CEOLmdARwgir23qyLZli{align-items:center;gap:10px;width:100%;min-width:0;display:flex}.t3GdEpW0f_oze0nbPG8X{flex-shrink:0;margin-left:auto;margin-right:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `RRda8SCSLagsA5KgyDGC`,
	"keywordName": `DQlregtNJkgFyyigQadG`,
	"cellWrapper": `PqysIWggYQGNzoj7FWrc`,
	"nameCellWrapper": `CEOLmdARwgir23qyLZli`,
	"nameToggle": `t3GdEpW0f_oze0nbPG8X`
};
export default ___CSS_LOADER_EXPORT___;
